import React from 'react';
import Logo from 'components/common/logo';
import styles from './index.module.scss';
import ButtonsBlock from './buttonsBlock';
import ScholarList from './scholarList';

const Header: React.FC = () => {
  return (
    <div className={styles.header}>
      <div className={styles.headerLogo}>
        <Logo />
      </div>
      <ScholarList />
      <ButtonsBlock />
    </div>
  );
};

export default Header;
